import './HistogramValueBottomAxisArea.css';
export var axisContainerStyle = '_7h7spr0-2-0-1';